import { Controller } from "@hotwired/stimulus"

// Reloads the calendar events turbo frame with the chosen preference so that
// deleted slots are included/excluded server-side. Doing it server-side keeps
// deleted slots out of the overlap layout, avoiding half-height lessons.
export default class extends Controller {
  toggle(event) {
    const show = event.target.checked;
    const frame = document.getElementById("school_calendar_object_data");
    if (!frame || !frame.src) return;

    const url = new URL(frame.src, window.location.origin);
    url.searchParams.set("show_deleted_slots", show);
    frame.src = url.toString();
  }
}
